// extracted by css-extract-rspack-plugin
export default {"partnerBanner":"PartnerBanner_partnerBanner__Lrkpp"};